document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initContador();
  initTilt();
  initCarruselManual();
});

function initCarruselManual() {
  document.querySelectorAll('[data-elx-carrusel-manual]').forEach(function (pista) {
    var wrap = pista.closest('.elx-rc-wrap') || pista.parentElement;
    if (!wrap) return;
    var prev = wrap.querySelector('[data-elx-carrusel-prev]');
    var next = wrap.querySelector('[data-elx-carrusel-next]');
    function desplazar(direccion) {
      var tarjeta = pista.querySelector('.elx-rc-card');
      var ancho = tarjeta ? tarjeta.getBoundingClientRect().width + 20 : pista.clientWidth * 0.8;
      pista.scrollBy({ left: direccion * ancho, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { desplazar(-1); });
    if (next) next.addEventListener('click', function () { desplazar(1); });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.elx-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  if (typeof IntersectionObserver === 'undefined') return;

  // Solo ahora, con el script ya cargado y funcionando, activamos el
  // efecto de aparición. Hasta este punto el contenido es visible por
  // defecto (ver elx-styles.css), así que un fallo o retraso del script
  // nunca deja nada oculto.
  els.forEach(function (el) { el.classList.add('elx-js-reveal'); });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-elx-delay') || 0;
        setTimeout(function () { entry.target.classList.add('elx-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad adicional: si por lo que sea el observer no dispara
  // para algún elemento, lo revelamos igual pasado un momento.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('elx-visible'); });
    observer.disconnect();
  }, 2500);
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-elx-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-elx-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-elx-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var nuevaSrc = mini.getAttribute('data-full');
      if (!nuevaSrc) return;
      principal.src = nuevaSrc;
      miniaturas.forEach(function (m) { m.classList.remove('elx-miniatura-activa'); });
      mini.classList.add('elx-miniatura-activa');
    });
  });
}

function initTilt() {
  var els = document.querySelectorAll('.elx-tilt');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(hover: none)').matches) return;
  els.forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = 'perspective(600px) rotateX(' + (y * -8) + 'deg) rotateY(' + (x * 8) + 'deg) translateY(-4px)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
    });
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-elx-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var final = Number(el.getAttribute('data-elx-contador'));
      var duracion = 1200;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        el.textContent = Math.floor(progreso * final);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = final;
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}
